import gql from "graphql-tag";

export default gql`
    type File {
        path: String
        filename: String
        mimetype: String
        encoding: String
        size: Int
    }
`
